var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-content"},[_c('div',{staticClass:"scroll-box"},[_c('div',{staticClass:"center",style:({ 'background-image': `url(${_vm.$lg(_vm.config, 'prize', '')})` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }